import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';

import config from '../../../../config';

import {getClient, getInterventions, getUsers, getDocuments, getDossierState} from './dataGetters';

const displayDocumentsTab = config.featureFlags.relationshipDocuments?.clientDocuments;

function updateClient(dispatch, params) {
  return getClient(params.clientId)
    .then(client => {
      dispatch({type: 'UPDATE_CLIENT', client});
    })
    .catch(() => {
      dispatch({type: 'ERROR', key: 'client'});
    });
}

function updateInterventions(dispatch, params) {
  return getInterventions(params)
    .then(({interventions = [], totalCount}) => {
      dispatch({type: 'UPDATE_INTERVENTIONS', interventions, totalCount});
    })
    .catch(() => {
      dispatch({type: 'ERROR', key: 'interventions'});
    });
}

function updateUsers(dispatch, params) {
  return getUsers(params)
    .then(({users = [], totalCount}) => {
      dispatch({type: 'UPDATE_USERS', users, totalCount});
    })
    .catch(() => {
      dispatch({type: 'ERROR', key: 'users'});
    });
}

function updateDocuments(dispatch, params) {
  return getDocuments(params)
    .then(({documents = [], totalCount}) => {
      dispatch({type: 'UPDATE_DOCUMENTS', documents, totalCount});
    })
    .catch(() => {
      dispatch({type: 'ERROR', key: 'documents'});
    });
}

function updateDossierState(dispatch, params) {
  return getDossierState(params)
    .then(({dossierState = {
      dossierState: DOSSIER_STATE.EMPTY,
      invalidDocuments: [],
      almostExpiredDocuments: []
    }}) => {
      dispatch({type: 'UPDATE_DOSSIER_STATE', dossierState});
    })
    .catch(() => {
      dispatch({type: 'ERROR', key: 'dossierState'});
    });
}

export default params => ({
  FETCH_DATA: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING_ALL'});
    await updateClient(dispatch, params);
    await updateInterventions(dispatch, params);
    await updateUsers(dispatch, params);

    if (displayDocumentsTab) {
      await updateDocuments(dispatch, params);
      await updateDossierState(dispatch, params);
    }
  },
  FETCH_DOCUMENTS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['documents', 'dossierState']});
    await updateDocuments(dispatch, params);
    await updateDossierState(dispatch, params);
  },
  FETCH_INTERVENTIONS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['interventions']});
    await updateInterventions(dispatch, params);
  },
  FETCH_USERS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['users']});
    await updateUsers(dispatch, params);
  }
});
